export default "__VITE_ASSET__C1owON9a__"